// extracted by mini-css-extract-plugin
var _1 = "G5Lj8";
export { _1 as "content" }
